import React from 'react'
import { Box, Typography } from '@mui/material'

import { DynamicInputForm, FormProps } from '../DynamicInputForm'
import Image from '../Image'
import { SectionDivider } from '../SectionDivider'

type HeroWithFormProps = {
  data: {
    title: string
    sub_title: string
    content: { children: { text: string }[] }[]
    right_image: { asset: { url: string } }
    input_form: FormProps['formProps']
    show_divider: boolean
  }
}

export const HeroWithForm = ({ data }: HeroWithFormProps) => (
  <Box sx={{ position: 'relative', pt: { xs: 8.5, laptop: 13 } }}>
    <Box
      sx={{
        width: '50%',
        background: 'linear-gradient(135.55deg,#3e35d1 6.09%,#86f8e0 116.03%)',
        bottom: 11,
        display: { xs: 'none', mobile: 'block' },
        position: 'absolute',
        top: 0,
        right: 0
      }}
    />

    <Box
      sx={{
        display: { mobile: 'flex' },
        maxWidth: 1152,
        mx: 'auto',
        pt: 8
      }}>
      <Box sx={{ width: { mobile: '50%' }, px: 3, pr: { mobile: 6 } }}>
        <Typography
          sx={{
            color: 'secondary.main',
            fontSize: { mobile: 24 },
            fontWeight: 'bold'
          }}>
          {data.sub_title?.toUpperCase()}
        </Typography>

        <Typography
          variant='h1'
          sx={{ fontSize: { xs: 24, mobile: 36, laptop: 54 }, mt: 2 }}>
          {data.title}
        </Typography>

        <Typography sx={{ mt: 2 }}>
          {data.content[0].children[0].text}
        </Typography>

        <Box sx={{ display: { xs: 'none', mobile: 'block' }, mt: 5.5 }}>
          <Image url={data.right_image.asset?.url} />
        </Box>
      </Box>

      <Box
        sx={{
          width: { mobile: '50%' },
          mt: { xs: 3.5, mobile: 0 },
          zIndex: 1
        }}>
        <DynamicInputForm
          formProps={data.input_form}
          sx={{
            background: {
              xs: 'linear-gradient(135.55deg,#3e35d1 6.09%,#86f8e0 116.03%)',
              mobile: 'none'
            },
            border: 'none',
            borderRadius: 0,
            pt: { mobile: 0, laptop: 0 },
            '.MuiInputBase-input': { bgcolor: 'text.primary' },
            '.MuiButton-contained': { color: 'text.primary' }
          }}
        />
      </Box>
    </Box>

    {data.show_divider && <SectionDivider />}
  </Box>
)
